import { notifyError } from "../utils/common-utils";
// import Logger from "../utils/logger";

export const action = (type, payload, meta = null) => ({
  type,
  payload,
  meta,
});
export const appApi = (url, method, headers = {}, body = '') =>
  new Promise(async (resolve, reject) => {
    let authToken = localStorage.getItem('authToken') ? localStorage.getItem('authToken').replaceAll('"', '') : null
    let options = {
      method,
      headers: {
        // accept: 'application/json',
        // 'Content-Type': 'application/json',
        "Authorization": `Bearer ${authToken}`,
        // "consumer_key": import.meta.env.VITE_CONSUMER_KEY,
        ...headers
      },
    };
    //console.log("Headers from app APi----->", options);
    if (body) {
      options = { ...options, body };
    }
    try {
      // console.log("Fetch mode >>>",options);
      const response = await fetch(url, options);
      const json = await response.json();
      // console.log("API RESPONSE",json)

      if (json.status) {
        console.log(" befor condition in APi method  ", (!json.status), " Result values ", json)
        if (!json.status) {
          resolve(json);
        } else {
          // json.response && 
          resolve(json);
        }
      } else {
        console.log(" Error condition in APi method  ", json.reason, " original data", json)
        resolve(json);
      }
    } catch (error) {
      console.log("Api hit error method ", error);
      reject(error);
    }
  })


// globalThis.appApi = appApi;